import {doNotTrack, isIE9, getServiceArea} from './consts';
import zPREFACE_Reader from './zPREFACEReader';
import brototype from 'brototype';
import inflight from "promise-inflight";
import { automationUserIdSets } from './common.js';
const Bro = brototype;


export let Raven;
let defMeta = {
	product:zPREFACE_Reader('track.product'),
	page:zPREFACE_Reader('track.page')
};
let inited = false;

export function init(_Raven, _defMeta = {}) {
	Raven = _Raven;
	defMeta = Object.assign({},defMeta,_defMeta);
	if(inited){
		console.error('sentryPsPlugin has inited more than once!')
	}
	inited = true
	console.log('ps-tracer inited!');
}


export function getPage() {
	if(defMeta.page){
		return defMeta.page
	}else{
		let markDom = document.querySelector('[data-ps-page]');
		return markDom ? Bro(markDom).iCanHaz('dataset.psPage') : location.pathname
	}
}

function getProductLevelInfo() {
	return {
		product: defMeta.product,
		// flink 0.0 bug
		// v: Bro(Raven).iCanHaz('_globalOptions.release') || '0.0',
		service_region: getServiceArea()
	}
}

export function getExtendData() {
	let userAgent = {
		b_lang: navigator.language,
		os: zPREFACE_Reader('UA.os.name') || Bro(Raven).iCanHaz('_globalContext.user.os')
	};
	if(isIE9){
		userAgent.browser = 'Internet Explorer';
		userAgent.b_ver = '9';
	}else{
		userAgent.browser = zPREFACE_Reader('UA.browser.name') || Bro(Raven).iCanHaz('_globalContext.user.browser');
		userAgent.b_ver = zPREFACE_Reader('UA.browser.version.original') || Bro(Raven).iCanHaz('_globalContext.user.b_ver');
	}
	let extendData = {};
	extendData.account_id_cipher = Bro(Raven).iCanHaz('_globalContext.user.account_id_cipher')
		|| defMeta.account_id_cipher
		|| zPREFACE_Reader('globalConfig.userInfo.encryptId')
		|| zPREFACE_Reader('globalConfig.user.encryptId')
		|| zPREFACE_Reader('CONFIG.USER.ENCRYPTID')
		|| zPREFACE_Reader('CONFIG.ENCRYPTID')
		|| zPREFACE_Reader('user_info.encrypt_id')
		|| Bro(Raven).iCanHaz('_globalContext.account_id_cipher') || '';
	extendData.company_id_cipher = Bro(Raven).iCanHaz('_globalContext.user.company_id_cipher')
		|| defMeta.company_id_cipher
		|| zPREFACE_Reader('globalConfig.companyInfo.encryptId')
		|| zPREFACE_Reader('company_info.encrypt_id')
		|| zPREFACE_Reader('globalConfig.companyInfo.encryptCompanyId')
		|| zPREFACE_Reader('globalConfig.company.encryptCompanyId')
		|| zPREFACE_Reader('globalConfig.user.encryptCompanyId')
		|| zPREFACE_Reader('CONFIG.COMPANY.ENCRYPTCOMPANYID')
		|| zPREFACE_Reader('CONFIG.ENCRYPTCOMPANYID')
		|| Bro(Raven).iCanHaz('_globalContext.company_id_cipher') || '';
	extendData.company_name = Bro(Raven).iCanHaz('_globalContext.user.company_name')
		|| defMeta.company_name
		|| zPREFACE_Reader('globalConfig.companyInfo.name')
		|| zPREFACE_Reader('company_info.name')
		|| zPREFACE_Reader('CONFIG.COMPANY');

	extendData.user_type = Bro(Raven).iCanHaz('_globalContext.user.user_type')
		|| defMeta.user_type
		|| zPREFACE_Reader('globalConfig.userInfo.userType')
		|| zPREFACE_Reader('user_info.account_type')
		|| zPREFACE_Reader('user_info.userType')
		|| '';

	extendData.first_login = Bro(Raven).iCanHaz('_globalContext.user.first_login')
		|| defMeta.first_login
		|| zPREFACE_Reader('globalConfig.userInfo.firstLogin')
		|| zPREFACE_Reader('user_info.first_login')
		|| false;

	if(!doNotTrack){
		extendData.user_agent = userAgent;
		extendData.client_resolution = Bro(window).iCanHaz('screen.width') + '*' + Bro(window).iCanHaz('screen.height');
	}

	extendData.page = getPage();//建议复写
	extendData.category = defMeta.category;

	Object.assign(extendData, getProductLevelInfo());
	return extendData;
}

export function getIdentityTraits() {
	const extendData = getExtendData();
	// const email = getUserEmail();
	const traits = {};
	// if (email) {
	// 	traits.email = email;
	// }
	if(extendData.company_id_cipher) {
		Object.assign(traits, {
			company_id: extendData.company_id_cipher,
			groupId: extendData.company_id_cipher
		})
	}
	return traits
}

export function getGroupTraits() {
	const extendData = getExtendData();
	if(!extendData.company_id_cipher) {
		return {}
	}
	return {
		company_id: extendData.company_id_cipher,
		organization: "organization",
		// account_name: extendData.company_name,
		name: extendData.company_name
	}
}

export function getSegmentTrackAdditionalProps() {
// 	添加company_id、company_name属性；
// 添加is_anonymous属性，其规则凡非用户名密码，命名用户主要是IP段登录用户，此部分用户的userId信息直接采用CID_{CompanyId}代替
	const extendData = getExtendData();
	return {
		user_type: extendData.user_type,
		first_login: extendData.first_login,
		is_anonymous: !extendData.account_id_cipher,
		company_id: extendData.company_id_cipher,
		groupId: extendData.company_id_cipher,
		region: extendData.service_region
	}
}

export function getUserEmail() {
	return Bro(Raven).iCanHaz('_globalContext.user.email')
		|| Bro(Raven).iCanHaz('_globalContext.email')
		|| defMeta.email
		|| zPREFACE_Reader('globalConfig.userInfo.email')
		|| zPREFACE_Reader('user_info.email')
		|| zPREFACE_Reader('globalConfig.user.email') || '';
}

export const asyncCall = (function (w) {
	const requestIdleCallback = w.requestIdleCallback ? w.requestIdleCallback : w.requestAnimationFrame;
	if (requestIdleCallback) {
		return function (func) {
			return requestIdleCallback(func, {timeout: 1000})
		}
	} else {
		return function (func) {
			setTimeout(func, 0);
		}
	}
})(window);



export function breadcrumb2userTrack(breadcrumb) {
	let bt = Object.assign({}, defMeta, breadcrumb);
	let ret = {};
	ret.action = bt.action;
	bt.module && (ret.module = bt.module);
	bt.page && (ret.page = bt.page);
	//Use ms now
	ret.action_time = parseInt(bt.timestamp * 1000);
	ret.action_type = bt.action_type || 'PROGRAM';

	bt.category && (ret.category = bt.category || ret.action_type);
	bt.attr && (ret.attr = bt.attr);
	bt.priority && (ret.priority = bt.priority);

	fullfillTrackData(ret);
	return ret;
}

function fullfillTrackData(trackData) {
	if(!trackData){return trackData}
	if(!trackData.action_type){
		trackData.action_type = 'CLICK';
	}

	if(!trackData.action_time){
		trackData.action_time = Date.now();
	}
	if(!trackData.action){
		trackData.action = 'UNKNOWN'
	}
	trackData.action = String(trackData.action);
	if(trackData.action && trackData.action.indexOf('-')>=0){
		console.warn(`Event name: "${trackData.action}" does not meet specifications, is it valid?`)
	}

	Object.assign(trackData, getProductLevelInfo());
	return trackData;
}

var isValidUser = undefined;
export function testIsValidUser (userInfo) {
	if(typeof isValidUser === "boolean") {
		return isValidUser
	}
	if(localStorage.getItem('isValidUser') === 'false'){
		isValidUser = false
	}else if(userInfo && typeof userInfo.email === "boolean"){
		isValidUser = true;
	}else{
		const account_id_cipher = (userInfo||getExtendData()||{}).account_id_cipher
		isValidUser = !automationUserIdSets.has(account_id_cipher);
	}
	return isValidUser;
}


export function loadScript(src) {
	return inflight(`loadScript_${src}`, () => {
		return new Promise(function (resolve, reject) {
			let s = document.createElement('script');
			s.async = true;
			s.src = src;
			s.onload = resolve;
			s.onerror = reject;
			document.head.appendChild(s);
		})
	})
}

export function pingCheck() {
	fetch('https://seg.patsnap.io/ping/2', {mode: 'cors',credentials:'omit', headers: {'content-type': 'text/plain'}})
			.then(resp => resp.text())
			.then(pongText => {
				if(pongText !== 'pong') {
					throw new Error('not valid')
				}
			})
		.catch(function (err) {
			const extendData = getExtendData();
			const errorText = `[SEGMENT_PING_FAIL]: ${extendData.company_id_cipher}`
			throw (errorText)
		})
}
